import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "@/hooks/trpc";
import { ProtocolKpisSection } from "@/features/harvest-protocol/protocol-kpis-section";

export const Route = createFileRoute("/harvests/protocols/$protocol_id/kpis")({
  component: RouteComponent,
});

function RouteComponent() {
  const { protocol_id } = Route.useParams();
  const { data: protocol } =
    trpc.harvest.protocols.getWithFullDetails.useQuery(protocol_id);

  if (!protocol) return null;

  return (
    <div className="h-full overflow-auto p-6">
      <ProtocolKpisSection
        protocolId={protocol_id}
        operations={protocol.operations ?? []}
      />
    </div>
  );
}
